// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_as-b";
export var colorBlue = "_as-8";
export var colorDot = "_as-0";
export var colorDotLarge = "_as-2";
export var colorDotSmall = "_as-1";
export var colorGreen = "_as-7";
export var colorGrey = "_as-3";
export var colorOrange = "_as-5";
export var colorPink = "_as-a";
export var colorPurple = "_as-9";
export var colorRed = "_as-4";
export var colorYellow = "_as-6";